import { defaultDictionaryValueMissing } from '../repository';

export type ActionKey = 'Close' | 'Open';

export const getDefaultActionValue = (key: ActionKey): string => {
	switch (key) {
		case 'Close':
			return 'Tilbage';
		case 'Open':
			return 'Åben';
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
